interface HbsSwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}

export function HbsSwitch({
  checked,
  onChange,
  disabled,
  label,
  id,
}: HbsSwitchProps): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      id={id}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex shrink-0 items-center w-[38px] h-[22px] rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
        checked ? 'bg-hbs-accent' : 'bg-hbs-border'
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-block w-[18px] h-[18px] rounded-full bg-white shadow-hbs-sm transition-transform ${
          checked ? 'translate-x-[18px]' : 'translate-x-[2px]'
        }`}
      />
    </button>
  );
}
